"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePromotionsByTag = void 0;
var react_1 = require("react");
var bonuses_1 = require("../bonuses");
var usePromotionsByTag = function (tag) {
    var _a = (0, bonuses_1.usePromotions)(), data = _a.data, isLoading = _a.isLoading, isValidating = _a.isValidating;
    var promotions = data === null || data === void 0 ? void 0 : data.filter(function (p) { return p.tags.includes(tag); });
    return (0, react_1.useMemo)(function () { return ({
        promotions: promotions || [],
        isLoading: isLoading,
        isValidating: isValidating,
    }); }, [promotions, isLoading]);
};
exports.usePromotionsByTag = usePromotionsByTag;
